import React from "react";
import Paragraph from "../Paragraph";

const HeroVerticalDelimiter = ({ ...props }) => {
	return (
		<Paragraph Tag="span" className="section-hero__vertical_delimiter" {...props}>
			|
		</Paragraph>
	);
};

HeroVerticalDelimiter.propTypes = {
	...Paragraph.propTypes,
};

export default HeroVerticalDelimiter;
